<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control checkbox-list-input" :class="config.cssClass">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="!optionsReady" class="loading-message">
            Getting data. Please wait...
        </div>
        <div v-else-if="asField">
            <display-value :id="config.id" :value="asFieldValue"></display-value>
        </div>
        <div v-else>
            <ul class="checkboxes-container" :style="{ height: config.height }" v-if="!updatingItems">
                <li v-for="(option,index) in parsedItems" :key="option.originKey || index" class="checkbox-wrapper">
                    <ejs-checkbox
                        v-bind="option"
                        v-model="value[option.value]"
                        :checked="value[option.value]"
                        v-on:click="action($event, 'onclick')"
                        v-on:change="localChange($event); action($event, 'onchange')"
                        :ref="config.ref || config.id"
                        :data-test-id="dataTestId + '_' + index"
                        :disabled="config.disabled"
                    ></ejs-checkbox>
                </li>
            </ul>
            <p v-if="config.message" class="input-info" v-html="ddStoreFilter(config.message)"></p>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

export const checkboxListComponent = {
    mixins: [controlMixins],
    data() {
        return {
            updatingItems: false
        };
    },
    computed: {
        asFieldValue: {
            get() {
                let textValue = [];
                this.items.forEach((item) => {
                    if (this.value && this.value[item.value]) {
                        textValue.push(item.label);
                    }
                });
                return textValue;
            }
        },
        parsedItems() {
            // map text prop to label prop
            return this.options.map((item) => {
                if (!item.label && item.text) item.label = item.text;
                return item;
            });
        }
    },
    methods: {
        localChange() {
            if (this && this.$parent && this.$parent.$emit) {
                this.$parent.$emit('update:value', this.value);
            }
        }
    },
    components: {
        "ejs-checkbox": defineAsyncComponent(() => import('@common/syncfusion/checkbox'))
    }
};

export default checkboxListComponent;
</script>

<style lang="css" scoped>
.checkbox-list-input {
    margin: 30px 0;
}
.checkboxes-container {
    display: flex;
    flex-direction: column;
    padding: 5px 0 0 10px;
    flex-wrap: wrap;
}
.checkbox-wrapper {
    margin: 5px 20px 5px 0;
    list-style: none;
}
.input-info {
    color: #2973b7;
}
</style>
